import { render } from "./CaapExamView.vue?vue&type=template&id=59fbd5e8&scoped=true"
import script from "./CaapExamView.vue?vue&type=script&lang=js"
export * from "./CaapExamView.vue?vue&type=script&lang=js"

import "./CaapExamView.vue?vue&type=style&index=0&id=59fbd5e8&scoped=true&lang=css"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59fbd5e8"]])

export default __exports__